import React, { Suspense, lazy, Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatBar from './components/FloatBar';
import LeadModal from './components/LeadModal';
import { useLeadModal } from './hooks/useLeadModal';

// v2.0: 关键页面直接导入（避免 chunk 加载失败）
import SolutionListPage from './pages/SolutionListPage';
import SolutionDetailPage from './pages/SolutionDetailPage';
import ProductDetailPage from './pages/ProductDetailPage';
import NotFound from './pages/NotFound';
const BUILD_ID = 'v2-20260626';

// 其他页面保持懒加载
const Home = lazy(() => import('./pages/Home'));
const NewsListPage = lazy(() => import('./pages/NewsListPage'));
const NewsDetailPage = lazy(() => import('./pages/NewsDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const PartnersPage = lazy(() => import('./pages/AboutSubPages').then(m => ({ default: m.PartnersPage })));
const QualificationPage = lazy(() => import('./pages/AboutSubPages').then(m => ({ default: m.QualificationPage })));
const CulturePage = lazy(() => import('./pages/AboutSubPages').then(m => ({ default: m.CulturePage })));
const RecruitPage = lazy(() => import('./pages/RecruitPage'));

const Loading = () => (
  <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'60vh' }}>
    <div style={{ width:40, height:40, border:'3px solid #e5e7eb', borderTopColor:'#1a56db', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

// Error Boundary
class RouteErrorBoundary extends Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '60px 20px', textAlign: 'center' }}>
          <h2 style={{ color: '#e74c3c' }}>页面加载出错</h2>
          <p style={{ color: '#666', margin: '10px 0' }}>{this.state.error?.message || '未知错误'}</p>
          <a href="/" className="btn btn-primary" style={{ display: 'inline-block' }}>返回首页</a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  const { isOpen, openModal, closeModal } = useLeadModal();

  return (
    <>
      <div data-build="v2.0-20260626" style={{display:'none'}}>{BUILD_ID}</div>
      <Navbar onGetSolution={openModal} />
      <main>
        <Suspense fallback={<Loading />}>
          <RouteErrorBoundary>
            <Routes>
              <Route path="/" element={<Home onGetSolution={openModal} />} />
              <Route path="/news" element={<NewsListPage category="news" />} />
              <Route path="/information" element={<NewsListPage category="information" />} />
              <Route path="/news-detail/:id" element={<NewsDetailPage />} />

              {/* v2.0: 方案分类页面 */}
              <Route path="/category/:categoryId" element={<SolutionListPage />} />

              {/* v2.0: 方案详情页 */}
              <Route path="/solution/:solutionId" element={<SolutionDetailPage onGetSolution={openModal} />} />

              {/* v2.0: 产品详情页 */}
              <Route path="/product/:id" element={<ProductDetailPage onGetSolution={openModal} />} />

              {/* 兼容旧路由 */}
              <Route path="/industry-:slug" element={<SolutionListPage />} />
              <Route path="/industry/:slug" element={<ProductDetailPage onGetSolution={openModal} />} />
              <Route path="/product-:id" element={<ProductDetailPage onGetSolution={openModal} />} />

              <Route path="/about" element={<AboutPage />} />
              <Route path="/about/partner" element={<PartnersPage />} />
              <Route path="/about/qualification" element={<QualificationPage />} />
              <Route path="/about/culture" element={<CulturePage />} />
              <Route path="/recruit" element={<RecruitPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </RouteErrorBoundary>
        </Suspense>
      </main>
      <Footer />
      <FloatBar onGetSolution={openModal} />
      <LeadModal isOpen={isOpen} onClose={closeModal} />
    </>
  );
}
